import { App } from 'data/terra/App';
import { AppVersion } from 'data/terra/AppVersion';

export function buildClientId(app: App, appVersion: AppVersion): string {
  return `${app.product.code}:${app.platform.code}:${app.market.code}:${appVersion.code}`;
}
